"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple component for displaying a hyperlink button
 * using either react-router Link component or a html anchor
 * @param {Object} children React children prop for wrapped content
 */
const LinkButton = ({
  children,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [otherProps.to && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledLinkButton, {
    to: otherProps.to,
    ...otherProps,
    children: children
  }), !otherProps.to && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AnchorButton, { ...otherProps,
    rel: otherProps.rel ? otherProps.rel : "noopener noreferrer",
    children: children
  })]
});

LinkButton.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  primary: _propTypes.default.bool,
  small: _propTypes.default.bool,
  neutral: _propTypes.default.bool,
  to: _propTypes.default.string,
  href: _propTypes.default.string
};
var _default = LinkButton;
exports.default = _default;